import i18n from "@/i18n";

export const appLocale = (): string => (i18n.language === "en" ? "en-IN" : (i18n.language === "fr" ? "fr-FR-u-nu-latn" : `${i18n.language}-IN-u-nu-latn`));
